//alert(true);
import './styles.editor.scss';
import { registerBlockType } from '@wordpress/blocks';
import ServerSideRender from '@wordpress/server-side-render';
import { __ } from '@wordpress/i18n';
import { Component, useState, useEffect, Fragment } from '@wordpress/element';
import IconWishListMember from '../icons/icon-wishlist-member';
import {
	Toolbar,
	ToolbarGroup,
	ToolbarItem,
	DropdownMenu,
	PanelBody,
	ToggleControl,
	Button,
	TextControl,
	Disabled,
} from '@wordpress/components';
import { RadioControl } from '@wordpress/components';
import {
	useBlockProps,
	ColorPalette,
	RichText,
	AlignmentToolbar,
	BlockControls,
	InspectorControls,
} from '@wordpress/block-editor';
// import { Fragment } from "react";
import Loading from '../loading';

registerBlockType('wishlist-box-basic-blocks/profilephoto', {
	title: __('Profile Photo', 'wishlist-box-basic'),
	description: __('Display Profile Photo', 'wishlist-box-basic'),
	category: 'wishlist-box-basic-blocks-category',
	keywords: [__('wlm'), __('member'), __('access')],
	icon: IconWishListMember,
	attributes: {
		content: {
			type: 'string',
			default: '[wlm_profilephoto cropping="circle" size="200"]',
		},
		returnformat: {
			type: 'string',
			default: 'htmlimage',
		},
		cropping: {
			type: 'string',
			default: 'circle',
		},
		size: {
			type: 'string',
			default: '200',
		},
		height: {
			type: 'string',
			default: '200',
		},
		width: {
			type: 'string',
			default: '200',
		},
		cssclasses: {
			type: 'string',
			default: '',
		},
	},
	edit(props) {
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();

		const content = attributes.content;
		const returnformat = attributes.returnformat;
		const cropping = attributes.cropping;
		const size = attributes.size;
		const height = attributes.height;
		const width = attributes.width;
		const cssclasses = attributes.cssclasses;

		const onChangecontent = (value) => {
			setAttributes({ content: value });
		};
		const onChangereturnformat = (value) => {
			setAttributes({ returnformat: value });
		};
		const onChangecropping = (value) => {
			setAttributes({ cropping: value });
		};
		const onChangesize = (value) => {
			setAttributes({ size: value });
		};
		const onChangeheight = (value) => {
			setAttributes({ height: value });
		};
		const onChangewidth = (value) => {
			setAttributes({ width: value });
		};
		const onChangecssclasses = (value) => {
			setAttributes({ cssclasses: value });
		};

		const ishtmlimage = () => {
			const returnformat = attributes.returnformat;

			if (returnformat == 'htmlimage') {
				return true;
			}
			return false;
		};

		useEffect(() => {
			console.log('content', content);
			console.log('returnformat', returnformat);
			console.log('cropping', cropping);
			console.log('size', size);
			console.log('cssclasses', cssclasses);
		}, [returnformat, cropping, size, cssclasses, ishtmlimage, content]);

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody title={__('Options', 'wishlist-member')}>
						<RadioControl
							className="wishlistmember-mergecodes-radiocontrol"
							label="Return Format"
							selected={returnformat}
							options={[
								{ label: 'HTML Image', value: 'htmlimage' },
								{ label: 'URL Only', value: 'urlonly' },
							]}
							onChange={(returnformat) => {
								onChangereturnformat(returnformat);
							}}
						/>
						{ishtmlimage() && (
							<RadioControl
								className="wishlistmember-mergecodes-radiocontrol"
								label="Cropping"
								selected={cropping}
								options={[
									{ label: 'Circle', value: 'circle' },
									{ label: 'Square', value: 'square' },
									{ label: 'No Cropping', value: '' },
								]}
								onChange={(cropping) => {
									onChangecropping(cropping);
								}}
							/>
						)}

						{ishtmlimage() && cropping && (
							<TextControl
								label="Size"
								value={size}
								onChange={(value) => onChangesize(value)}
							/>
						)}
						{ishtmlimage() && !cropping && (
							<TextControl
								label="Height"
								value={height}
								onChange={(value) => onChangeheight(value)}
							/>
						)}
						{ishtmlimage() && !cropping && (
							<TextControl
								label="Width"
								value={width}
								onChange={(value) => onChangewidth(value)}
							/>
						)}
						{ishtmlimage() && (
							<TextControl
								label="CSS Classes"
								value={cssclasses}
								onChange={(value) => onChangecssclasses(value)}
							/>
						)}
					</PanelBody>
				</InspectorControls>
				<div {...blockProps}>
					<Disabled>
						<ServerSideRender
							block="wishlist-box-basic-blocks/profilephoto"
							attributes={attributes}
							LoadingResponsePlaceholder={Loading}
						/>
					</Disabled>
				</div>
			</Fragment>
		);
	},
	save(props) {
		return null;
	},
});
